import { productCarouselProductCondensedStyles as styles } from "@insite/content-library/Components/ProductCarouselProductCondensed";
import getColor from "@insite/mobius/utilities/getColor";
import { colorStrings, mediaQueriesBP } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

styles.container = {
    ...styles.container,
    gap: 0,
    css: css`
        background-color: ${getColor(colorStrings.commonGlobalWhite)};
        border-radius: 4px;
        padding: 8px;

        ${mediaQueriesBP.minMD} {
            padding: 16px;
        }
    `,
    offsetCss: css`
        justify-content: flex-start;
        position: relative;
        gap: 8px;

        ${mediaQueriesBP.minMD} {
            gap: 10px;
        }
    `,
};

styles.condensedActionsTemplateGridItem = {
    ...styles.condensedActionsTemplateGridItem,
    css: css`
        ${styles.condensedActionsTemplateGridItem?.css}
        max-width: 100%;
        position: absolute;
        top: 0;
        left: 90%;
    `,
};
